import { type StyledComponentProps, useStyledSystem } from "@hopper-ui/components";
import classNames from "classnames";
import { Button as RACButton, type ButtonProps as RACButtonProps } from "react-aria-components";
import "./CustomButton.css";

export type CustomButtonProps = StyledComponentProps<RACButtonProps>;

export const CustomButton = (props: CustomButtonProps) => {
    const { isDisabled } = props;
    const defaultProps: CustomButtonProps = {
        cursor: isDisabled ? "not-allowed" : "pointer"
    };

    const { stylingProps, ...ownProps } = useStyledSystem({ ...defaultProps, ...props });
    const { className, style } = ownProps;

    const mergedClassNames = classNames("hop-Button", stylingProps.className, "wai-custom-button", className);

    const mergedStyles = { ...stylingProps.style, ...style };

    return (
        <RACButton
            {...ownProps}
            style={mergedStyles}
            className={mergedClassNames}
        />
    );
};
